// Option 3: Clipboard with Checkmark - Selected Logo
export default function Logo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <div className="relative">
        <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center transform rotate-6">
          <i className="ri-file-list-3-line text-white text-xl"></i>
        </div>
        <div className="absolute -top-1 -right-1 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center">
          <i className="ri-check-line text-white text-xs font-bold"></i>
        </div>
      </div>
      <div className="flex flex-col leading-tight">
        <span className="text-lg font-bold text-gray-900">Apex</span>
        <span className="text-xs font-semibold text-teal-600 -mt-1">HOME INSPECTION</span>
      </div>
    </div>
  );
}
